import { inject, injectable } from 'inversify-props';
import { IHttpClient, ILogger, ISettings } from '../common';
import { ArtistImage, PagedResult } from '../../models';


export interface IArtistImageService {

	get(artistId: string, imageId: string): Promise<ArtistImage>;
	list(artistId: string): Promise<ArtistImage[]>;
	page(artistId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ArtistImage>>;
	save(image: ArtistImage): Promise<ArtistImage>;
	delete(artistId: string, imageId: string): Promise<any>;
	revert(artistId: string): Promise<any>;
}

@injectable()
export class ArtistImageService implements IArtistImageService {


	constructor(
		@inject('IHttpClient') private httpClient: IHttpClient,
		@inject('ILogger') private logger: ILogger,
		@inject('ISettings') private settings: ISettings) {}


	public get(artistId: string, imageId: string): Promise<ArtistImage> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/images/${imageId}`;
		return this.httpClient.get<ArtistImage>(url);
	}

	public list(artistId: string): Promise<ArtistImage[]> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/images`;
		return this.httpClient.get<ArtistImage[]>(url);
	}

	public page(artistId: string, pageIndex: number, pageSize: number): Promise<PagedResult<ArtistImage>> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/images/${pageIndex}/${pageSize}`;
		return this.httpClient.get<PagedResult<ArtistImage>>(url);
	}

	public save(image: ArtistImage): Promise<ArtistImage> {
		let url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${image.artistId}/images`;
		if (image.id !== null && image.id !== undefined && image.id !== '') {
			url += `/${image.id}`;
			return this.httpClient.put(url, image);
		}
		return this.httpClient.post(url, image);
	}

	public delete(artistId: string, imageId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/images/${imageId}`;
		return this.httpClient.delete(url);
	}

	public revert(artistId: string): Promise<any> {
		const url = `${this.settings.baseUrl}${this.settings.artistBaseUrl}/${artistId}/images/revert`;
		return this.httpClient.post(url, null);
	}


}
